import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

export type ReportType = 'WA' | 'MWA' | 'BQ' | 'ATP';
export type ListType = 'WA' | 'BQ' | 'ATP';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

    router = inject(Router);

//   constructor(private router: Router) { }

    navigateToReport(id: string, type: ReportType, returnParams?: any) {

        const routeMap: Record<ReportType, string> = {
        WA: 'editwa',
        MWA: 'editmwa',
        BQ: 'editbq',
        ATP: 'editatp'
        };

        const route = routeMap[type];

        this.router.navigate([`/reports/${route}`, id], {
        state: {
            returnUrl: this.router.url.split('?')[0],
            returnParams: returnParams
        }
        });
    }

    getReturnState() {
    const state = history.state;

    if (state && state.returnUrl) {
        const returnUrl = state.returnUrl;
        const returnParams = state.returnParams || {};

        sessionStorage.setItem('returnUrl', returnUrl);
        sessionStorage.setItem('returnParams', JSON.stringify(returnParams));

        return { returnUrl, returnParams };
    }

    // ✅ fallback (refresh-safe)
    const returnUrl = sessionStorage.getItem('returnUrl') || '/';
    const returnParams = JSON.parse(
        sessionStorage.getItem('returnParams') || '{}'
    );

    return { returnUrl, returnParams };
    }  

navigateToPage(
  path: string,
  queryParams?: any,
  returnParams?: any
) {
  const currentState = history.state;

  const isInitialNavigation = !currentState?.returnUrl;

  const returnUrl = isInitialNavigation
    ? this.router.url.split('?')[0]
    : currentState.returnUrl;

  const finalReturnParams = isInitialNavigation
    ? returnParams || this.getCurrentQueryParams()
    : currentState.returnParams;

  this.router.navigate([path], {
    queryParams,
    state: {
      returnUrl,
      returnParams: finalReturnParams
    }
  });
}

getCurrentQueryParams() {
  const tree = this.router.parseUrl(this.router.url);
  return tree.queryParams || {};
}

goBack(router: Router) {
  const state = history.state;

  const returnUrl = state?.returnUrl;
  const returnParams = state?.returnParams || {};

  if (returnUrl) {
    router.navigate([returnUrl], {
      queryParams: returnParams
    });
  } else {
    // ✅ fallback = browser history
    window.history.back();
  }
}
}
